import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { marketQueryKeys } from '@/entities/market';
import { logout, useSessionStore } from '@/entities/session';
import { ROUTES } from '@/shared/config';
import { logger } from '@/shared/lib';

/**
 * «Выйти» (ACC 4.7.1): POST /admin/auth/logout → экран входа. Локальная сессия очищается
 * даже при сетевой ошибке выхода (сервер отзовёт сессию по сроку).
 */
export function useLogout() {
  const queryClient = useQueryClient();
  const clearSession = useSessionStore((state) => state.clear);
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  const run = useCallback(async () => {
    setPending(true);
    try {
      await logout();
    } catch (error) {
      logger.warn('auth: logout request failed', { error: String(error) });
    } finally {
      clearSession();
      // Данные участника — удаляются; конфигурация рынка (бренд, языки) нужна и экрану входа.
      queryClient.removeQueries({
        predicate: (query) => query.queryKey[0] !== marketQueryKeys.config[0],
      });
      setPending(false);
      navigate(ROUTES.login, { replace: true });
    }
  }, [clearSession, navigate, queryClient]);

  return { logout: run, pending };
}
